import { render } from "./RelationsTable.vue?vue&type=template&id=0b78da72&scoped=true"
import script from "./RelationsTable.vue?vue&type=script&lang=js"
export * from "./RelationsTable.vue?vue&type=script&lang=js"

import "./RelationsTable.vue?vue&type=style&index=0&id=0b78da72&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b78da72"]])

export default __exports__